import axiosInstance from './axiosInstance';

const advancedDataApi = {
    upsertAdvanceReportData: (payload) => axiosInstance.post('/advanced-data/upsert', payload),
    getAdvanceReportDataByUserId: (userId) => axiosInstance.get(`/advanced-data/user/${userId}`),
};

export default advancedDataApi;
